import ComplementryItems from "./ComplementryItems";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { productAddedMain } from "../../Utils/helper";

const ComplementryProducts = ({ itemData, closePopup }) => {
  const dispatch = useDispatch();
  const [attribute_id, setAttributeId] = useState(0);
  const [modifier_id, setModifierId] = useState('');
  const modalStyle = {
    'display': `block`,
    'padding-left': '0px'
  };
  const chooseVariety = (attribute_id, modifier_id) => {
    setAttributeId(attribute_id)
    setModifierId(modifier_id)
  };

  const productAddHandleClick = async (name, id, price, comment) => {
      let resp = await productAddedMain(name, id, price, comment, attribute_id, modifier_id, dispatch);
      closePopup()
  };
  console.log('bbbbbbbb -----')
  return (

    <div className="modal fade select_milkContent show" id={"milk_selectModal"+itemData.id} tabindex="-1" aria-labelledby="course_loginModal" aria-modal="true" role="dialog" style={modalStyle}>
      <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
          {itemData?.complements?.map((option, index) =>
          <>
              <div className="modal-header" >  
                  <h2>{option.name}</h2>                                              
                  <button type="button" className="btn-close" onClick={closePopup}><i className="fa-light fa-xmark"></i></button>
              </div>
              <div className="modal-body">
                  <div className="row gx-40">
                      {option?.products?.map((item, index) => (
                        <ComplementryItems 
                        item={item} 
                        key={index}
                        chooseVariety={chooseVariety}
                        selectedAttributeId={attribute_id}
                        selectedModifierId={modifier_id} />
                      ))}
                  </div>

                  <div className="footerSite">
                      <div className="botton_group mt-0 d-flex flex-wrap justify-content-between">
                          <a href="#" onClick={closePopup} className="btn cancelBtn">Cancelar</a>
                          {(attribute_id) ? (
                            <a href="#" onClick={() =>
                                  productAddHandleClick(itemData.name, itemData.id, itemData.price, "")
                              } className="btn ConfirmBtn active">Agregar</a>
                          ) : (
                            <a href="#" className="btn ConfirmBtn">Agregar</a>
                          )}
                      </div>
                  </div>
                </div>
                </>
                )}
              </div>
          </div>
      </div>
    
  );
};

export default ComplementryProducts;
